<template>
  <div v-cloak>
    <button style="margin-right:3vw"
      :class="startState"
      @click="$emit('start')">start</button>
    <button style="margin-right:3vw"
      :class="stopState"
      @click="$emit('stop')">stop</button>
    <button 
      :class="resetState"
      @click="$emit('reset')">reset</button>
  </div>
</template>

<script>
  export default {
    name: 'controls',
    
    props: {
      mode: String,
    },
    emits:["start","stop","reset"],
    data() {
      return {
      }
    },
    computed: {
      startState() {
        return this.mode == "setup"  || this.mode == "paused" ? "start" : "start-readonly";;
      },
      stopState() {
        return this.mode == "running" ? "stop" : "stop-readonly";
      },
      resetState() {
        return this.mode == "paused" || this.mode == "done" ? "reset" : "reset-readonly";
      }
    },
    methods: {
    },
    watch: {
    },
    mounted() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  button {
    font-size:2.5vw;
    padding:1vw 2vw;
    border:none;
    box-shadow: none;
    outline:none;  
    border-radius:.5vw 
  }

  .stop {
    color:white;
    background-color:red;
  }

  .stop-readonly {
    color:rgb(151, 151, 151);
    background-color:#400c06;
  }
  .start {
    color:white;
    background-color:rgb(53, 143, 26)
  }
  .start-readonly {
    color:rgb(159, 158, 158);
    background-color:rgb(22, 49, 13);
  }
  .reset {
    color:white;
    background-color:rgb(128,128,128);
  }
  .reset-readonly {
    color:rgb(107, 106, 106); 
    background-color:rgb(33, 33, 33)
  }
</style>
